export const countryCodes = [
  {
    countryAlias: 'Afghanistan',
    phoneCode: '+93',
  },
  {
    countryAlias: 'Albania',
    phoneCode: '+355',
  },
  {
    countryAlias: 'Algeria',
    phoneCode: '+213',
  },
  {
    countryAlias: 'AmericanSamoa',
    phoneCode: '+1-684',
  },
  {
    countryAlias: 'Andorra',
    phoneCode: '+376',
  },
  {
    countryAlias: 'Angola',
    phoneCode: '+244',
  },
  {
    countryAlias: 'Anguilla',
    phoneCode: '+1-264',
  },
  {
    countryAlias: 'Antarctica',
    phoneCode: '+672',
  },
  {
    countryAlias: 'AntiguaandBarbuda',
    phoneCode: '+1-268',
  },
  {
    countryAlias: 'Argentina',
    phoneCode: '+54',
  },
  {
    countryAlias: 'Armenia',
    phoneCode: '+374',
  },
  {
    countryAlias: 'Aruba',
    phoneCode: '+297',
  },
  {
    countryAlias: 'Australia',
    phoneCode: '+61',
  },
  {
    countryAlias: 'Austria',
    phoneCode: '+43',
  },
  {
    countryAlias: 'Azerbaijan',
    phoneCode: '+994',
  },
  {
    countryAlias: 'Bahamas',
    phoneCode: '+1-242',
  },
  {
    countryAlias: 'Bahrain',
    phoneCode: '+973',
  },
  {
    countryAlias: 'Bangladesh',
    phoneCode: '+880',
  },
  {
    countryAlias: 'Barbados',
    phoneCode: '+1-246',
  },
  {
    countryAlias: 'Belarus',
    phoneCode: '+375',
  },
  {
    countryAlias: 'Belgium',
    phoneCode: '+32',
  },
  {
    countryAlias: 'Belize',
    phoneCode: '+501',
  },
  {
    countryAlias: 'Benin',
    phoneCode: '+229',
  },
  {
    countryAlias: 'Bermuda',
    phoneCode: '+1-441',
  },
  {
    countryAlias: 'Bhutan',
    phoneCode: '+975',
  },
  {
    countryAlias: 'Bolivia',
    phoneCode: '+591',
  },
  {
    countryAlias: 'BosniaandHerzegovina',
    phoneCode: '+387',
  },
  {
    countryAlias: 'Botswana',
    phoneCode: '+267',
  },
  {
    countryAlias: 'Brazil',
    phoneCode: '+55',
  },
  {
    countryAlias: 'BritishIndianOceanTerritory',
    phoneCode: '+246',
  },
  {
    countryAlias: 'VirginIslandsBritish',
    phoneCode: '+1-284',
  },
  {
    countryAlias: 'BruneiDarussalam',
    phoneCode: '+673',
  },
  {
    countryAlias: 'Bulgaria',
    phoneCode: '+359',
  },
  {
    countryAlias: 'BurkinaFaso',
    phoneCode: '+226',
  },
  {
    countryAlias: 'Burundi',
    phoneCode: '+257',
  },
  {
    countryAlias: 'Cambodia',
    phoneCode: '+855',
  },
  {
    countryAlias: 'Cameroon',
    phoneCode: '+237',
  },
  {
    countryAlias: 'Canada',
    phoneCode: '+1',
  },
  {
    countryAlias: 'CapeVerde',
    phoneCode: '+238',
  },
  {
    countryAlias: 'CaymanIslands',
    phoneCode: '+1-345',
  },
  {
    countryAlias: 'CentralAfricanRepublic',
    phoneCode: '+236',
  },
  {
    countryAlias: 'Chad',
    phoneCode: '+235',
  },
  {
    countryAlias: 'Chile',
    phoneCode: '+56',
  },
  {
    countryAlias: 'China',
    phoneCode: '+86',
  },
  {
    countryAlias: 'ChristmasIsland',
    phoneCode: '+61',
  },
  {
    countryAlias: 'CocosKeelingIslands',
    phoneCode: '+61',
  },
  {
    countryAlias: 'Colombia',
    phoneCode: '+57',
  },
  {
    countryAlias: 'Comoros',
    phoneCode: '+269',
  },
  {
    countryAlias: 'CookIslands',
    phoneCode: '+682',
  },
  {
    countryAlias: 'CostaRica',
    phoneCode: '+506',
  },
  {
    countryAlias: 'Croatia',
    phoneCode: '+385',
  },
  {
    countryAlias: 'Cuba',
    phoneCode: '+53',
  },
  {
    countryAlias: 'Curaçao',
    phoneCode: '+599',
  },
  {
    countryAlias: 'Cyprus',
    phoneCode: '+357',
  },
  {
    countryAlias: 'Czechia',
    phoneCode: '+420',
  },
  {
    countryAlias: 'CongoDemocraticRepublic',
    phoneCode: '+243',
  },
  {
    countryAlias: 'Denmark',
    phoneCode: '+45',
  },
  {
    countryAlias: 'Djibouti',
    phoneCode: '+253',
  },
  {
    countryAlias: 'Dominica',
    phoneCode: '+1-767',
  },
  {
    countryAlias: 'DominicanRepublic',
    phoneCode: '+1-809, 1-829, 1-849',
  },
  {
    countryAlias: 'Timor-Leste',
    phoneCode: '+670',
  },
  {
    countryAlias: 'Ecuador',
    phoneCode: '+593',
  },
  {
    countryAlias: 'Egypt',
    phoneCode: '+20',
  },
  {
    countryAlias: 'ElSalvador',
    phoneCode: '+503',
  },
  {
    countryAlias: 'EquatorialGuinea',
    phoneCode: '+240',
  },
  {
    countryAlias: 'Eritrea',
    phoneCode: '+291',
  },
  {
    countryAlias: 'Estonia',
    phoneCode: '+372',
  },
  {
    countryAlias: 'Ethiopia',
    phoneCode: '+251',
  },
  {
    countryAlias: 'FalklandIslandsMalvinas',
    phoneCode: '+500',
  },
  {
    countryAlias: 'FaroeIslands',
    phoneCode: '+298',
  },
  {
    countryAlias: 'Fiji',
    phoneCode: '+679',
  },
  {
    countryAlias: 'Finland',
    phoneCode: '+358',
  },
  {
    countryAlias: 'France',
    phoneCode: '+33',
  },
  {
    countryAlias: 'FrenchPolynesia',
    phoneCode: '+689',
  },
  {
    countryAlias: 'Gabon',
    phoneCode: '+241',
  },
  {
    countryAlias: 'Gambia',
    phoneCode: '+220',
  },
  {
    countryAlias: 'Georgia',
    phoneCode: '+995',
  },
  {
    countryAlias: 'Germany',
    phoneCode: '+49',
  },
  {
    countryAlias: 'Ghana',
    phoneCode: '+233',
  },
  {
    countryAlias: 'Gibraltar',
    phoneCode: '+350',
  },
  {
    countryAlias: 'Greece',
    phoneCode: '+30',
  },
  {
    countryAlias: 'Greenland',
    phoneCode: '+299',
  },
  {
    countryAlias: 'Grenada',
    phoneCode: '+1-473',
  },
  {
    countryAlias: 'Guam',
    phoneCode: '+1-671',
  },
  {
    countryAlias: 'Guatemala',
    phoneCode: '+502',
  },
  {
    countryAlias: 'Guernsey',
    phoneCode: '+44-1481',
  },
  {
    countryAlias: 'Guinea',
    phoneCode: '+224',
  },
  {
    countryAlias: 'Guinea-Bissau',
    phoneCode: '+245',
  },
  {
    countryAlias: 'Guyana',
    phoneCode: '+592',
  },
  {
    countryAlias: 'Haiti',
    phoneCode: '+509',
  },
  {
    countryAlias: 'Honduras',
    phoneCode: '+504',
  },
  {
    countryAlias: 'HongKong',
    phoneCode: '+852',
  },
  {
    countryAlias: 'Hungary',
    phoneCode: '+36',
  },
  {
    countryAlias: 'Iceland',
    phoneCode: '+354',
  },
  {
    countryAlias: 'India',
    phoneCode: '+91',
  },
  {
    countryAlias: 'Indonesia',
    phoneCode: '+62',
  },
  {
    countryAlias: 'Iran',
    phoneCode: '+98',
  },
  {
    countryAlias: 'Iraq',
    phoneCode: '+964',
  },
  {
    countryAlias: 'Ireland',
    phoneCode: '+353',
  },
  {
    countryAlias: 'IsleofMan',
    phoneCode: '+44-1624',
  },
  {
    countryAlias: 'Israel',
    phoneCode: '+972',
  },
  {
    countryAlias: 'Italy',
    phoneCode: '+39',
  },
  {
    countryAlias: "Côted'Ivoire",
    phoneCode: '+225',
  },
  {
    countryAlias: 'Jamaica',
    phoneCode: '+1-876',
  },
  {
    countryAlias: 'Japan',
    phoneCode: '+81',
  },
  {
    countryAlias: 'Jersey',
    phoneCode: '+44-1534',
  },
  {
    countryAlias: 'Jordan',
    phoneCode: '+962',
  },
  {
    countryAlias: 'Kazakhstan',
    phoneCode: '+7',
  },
  {
    countryAlias: 'Kenya',
    phoneCode: '+254',
  },
  {
    countryAlias: 'Kiribati',
    phoneCode: '+686',
  },
  {
    countryAlias: 'Kosovo',
    phoneCode: '+383',
  },
  {
    countryAlias: 'Kuwait',
    phoneCode: '+965',
  },
  {
    countryAlias: 'Kyrgyzstan',
    phoneCode: '+996',
  },
  {
    countryAlias: "LaoPeople'sDemocraticRepublic",
    phoneCode: '+856',
  },
  {
    countryAlias: 'Latvia',
    phoneCode: '+371',
  },
  {
    countryAlias: 'Lebanon',
    phoneCode: '+961',
  },
  {
    countryAlias: 'Lesotho',
    phoneCode: '+266',
  },
  {
    countryAlias: 'Liberia',
    phoneCode: '+231',
  },
  {
    countryAlias: 'Libya',
    phoneCode: '+218',
  },
  {
    countryAlias: 'Liechtenstein',
    phoneCode: '+423',
  },
  {
    countryAlias: 'Lithuania',
    phoneCode: '+370',
  },
  {
    countryAlias: 'Luxembourg',
    phoneCode: '+352',
  },
  {
    countryAlias: 'Macao',
    phoneCode: '+853',
  },
  {
    countryAlias: 'NorthMacedonia',
    phoneCode: '+389',
  },
  {
    countryAlias: 'Madagascar',
    phoneCode: '+261',
  },
  {
    countryAlias: 'Malawi',
    phoneCode: '+265',
  },
  {
    countryAlias: 'Malaysia',
    phoneCode: '+60',
  },
  {
    countryAlias: 'Maldives',
    phoneCode: '+960',
  },
  {
    countryAlias: 'Mali',
    phoneCode: '+223',
  },
  {
    countryAlias: 'Malta',
    phoneCode: '+356',
  },
  {
    countryAlias: 'MarshallIslands',
    phoneCode: '+692',
  },
  {
    countryAlias: 'Mauritania',
    phoneCode: '+222',
  },
  {
    countryAlias: 'Mauritius',
    phoneCode: '+230',
  },
  {
    countryAlias: 'Mayotte',
    phoneCode: '+262',
  },
  {
    countryAlias: 'Mexico',
    phoneCode: '+52',
  },
  {
    countryAlias: 'MicronesiaFederatedStatesof',
    phoneCode: '+691',
  },
  {
    countryAlias: 'Moldova',
    phoneCode: '+373',
  },
  {
    countryAlias: 'Monaco',
    phoneCode: '+377',
  },
  {
    countryAlias: 'Mongolia',
    phoneCode: '+976',
  },
  {
    countryAlias: 'Montenegro',
    phoneCode: '+382',
  },
  {
    countryAlias: 'Montserrat',
    phoneCode: '+1-664',
  },
  {
    countryAlias: 'Morocco',
    phoneCode: '+212',
  },
  {
    countryAlias: 'Mozambique',
    phoneCode: '+258',
  },
  {
    countryAlias: 'Myanmar',
    phoneCode: '+95',
  },
  {
    countryAlias: 'Namibia',
    phoneCode: '+264',
  },
  {
    countryAlias: 'Nauru',
    phoneCode: '+674',
  },
  {
    countryAlias: 'Nepal',
    phoneCode: '+977',
  },
  {
    countryAlias: 'Netherlands',
    phoneCode: '+31',
  },
  {
    countryAlias: 'NetherlandsAntilles', // Note: This country code "AN" is deprecated in ISO 3166-1.
    phoneCode: '+599',
  },
  {
    countryAlias: 'NewCaledonia',
    phoneCode: '+687',
  },
  {
    countryAlias: 'NewZealand',
    phoneCode: '+64',
  },
  {
    countryAlias: 'Nicaragua',
    phoneCode: '+505',
  },
  {
    countryAlias: 'Niger',
    phoneCode: '+227',
  },
  {
    countryAlias: 'Nigeria',
    phoneCode: '+234',
  },
  {
    countryAlias: 'Niue',
    phoneCode: '+683',
  },
  {
    countryAlias: 'NorthKorea',
    phoneCode: '+850',
  },
  {
    countryAlias: 'NorthernMarianaIslands',
    phoneCode: '+1-670',
  },
  {
    countryAlias: 'Norway',
    phoneCode: '+47',
  },
  {
    countryAlias: 'Oman',
    phoneCode: '+968',
  },
  {
    countryAlias: 'Pakistan',
    phoneCode: '+92',
  },
  {
    countryAlias: 'Palau',
    phoneCode: '+680',
  },
  {
    countryAlias: 'PalestineStateof',
    phoneCode: '+970',
  },
  {
    countryAlias: 'Panama',
    phoneCode: '+507',
  },
  {
    countryAlias: 'PapuaNewGuinea',
    phoneCode: '+675',
  },
  {
    countryAlias: 'Paraguay',
    phoneCode: '+595',
  },
  {
    countryAlias: 'Peru',
    phoneCode: '+51',
  },
  {
    countryAlias: 'Philippines',
    phoneCode: '+63',
  },
  {
    countryAlias: 'Pitcairn',
    phoneCode: '+64',
  },
  {
    countryAlias: 'Poland',
    phoneCode: '+48',
  },
  {
    countryAlias: 'Portugal',
    phoneCode: '+351',
  },
  {
    countryAlias: 'PuertoRico',
    phoneCode: '+1-787, 1-939',
  },
  {
    countryAlias: 'Qatar',
    phoneCode: '+974',
  },
  {
    countryAlias: 'Congo',
    phoneCode: '+242',
  },
  {
    countryAlias: 'Réunion',
    phoneCode: '+262',
  },
  {
    countryAlias: 'Romania',
    phoneCode: '+40',
  },
  {
    countryAlias: 'RussianFederation',
    phoneCode: '+7',
  },
  {
    countryAlias: 'Rwanda',
    phoneCode: '+250',
  },
  {
    countryAlias: 'SaintBarthélemy',
    phoneCode: '+590',
  },
  {
    countryAlias: 'SaintHelenaAscensionandTristanDaCunha',
    phoneCode: '+290',
  },
  {
    countryAlias: 'SaintKittsandNevis',
    phoneCode: '+1-869',
  },
  {
    countryAlias: 'SaintLucia',
    phoneCode: '+1-758',
  },
  {
    countryAlias: 'SaintMartinFrenchpart',
    phoneCode: '+590',
  },
  {
    countryAlias: 'SaintPierreandMiquelon',
    phoneCode: '+508',
  },
  {
    countryAlias: 'SaintVincentandtheGrenadines',
    phoneCode: '+1-784',
  },
  {
    countryAlias: 'Samoa',
    phoneCode: '+685',
  },
  {
    countryAlias: 'SanMarino',
    phoneCode: '+378',
  },
  {
    countryAlias: 'SaoTomeandPrincipe',
    phoneCode: '+239',
  },
  {
    countryAlias: 'SaudiArabia',
    phoneCode: '+966',
  },
  {
    countryAlias: 'Senegal',
    phoneCode: '+221',
  },
  {
    countryAlias: 'Serbia',
    phoneCode: '+381',
  },
  {
    countryAlias: 'Seychelles',
    phoneCode: '+248',
  },
  {
    countryAlias: 'SierraLeone',
    phoneCode: '+232',
  },
  {
    countryAlias: 'Singapore',
    phoneCode: '+65',
  },
  {
    countryAlias: 'SintMaartenDutchpart',
    phoneCode: '+1-721',
  },
  {
    countryAlias: 'Slovakia',
    phoneCode: '+421',
  },
  {
    countryAlias: 'Slovenia',
    phoneCode: '+386',
  },
  {
    countryAlias: 'SolomonIslands',
    phoneCode: '+677',
  },
  {
    countryAlias: 'Somalia',
    phoneCode: '+252',
  },
  {
    countryAlias: 'SouthAfrica',
    phoneCode: '+27',
  },
  {
    countryAlias: 'SouthKorea',
    phoneCode: '+82',
  },
  {
    countryAlias: 'SouthSudan',
    phoneCode: '+211',
  },
  {
    countryAlias: 'Spain',
    phoneCode: '+34',
  },
  {
    countryAlias: 'SriLanka',
    phoneCode: '+94',
  },
  {
    countryAlias: 'Sudan',
    phoneCode: '+249',
  },
  {
    countryAlias: 'Suriname',
    phoneCode: '+597',
  },
  {
    countryAlias: 'SvalbardandJanMayen',
    phoneCode: '+47',
  },
  {
    countryAlias: 'Eswatini',
    phoneCode: '+268',
  },
  {
    countryAlias: 'Sweden',
    phoneCode: '+46',
  },
  {
    countryAlias: 'Switzerland',
    phoneCode: '+41',
  },
  {
    countryAlias: 'SyrianArabRepublic',
    phoneCode: '+963',
  },
  {
    countryAlias: 'TaiwanProvinceofChina',
    phoneCode: '+886',
  },
  {
    countryAlias: 'Tajikistan',
    phoneCode: '+992',
  },
  {
    countryAlias: 'TanzaniaUnitedRepublicof',
    phoneCode: '+255',
  },
  {
    countryAlias: 'Thailand',
    phoneCode: '+66',
  },
  {
    countryAlias: 'Togo',
    phoneCode: '+228',
  },
  {
    countryAlias: 'Tokelau',
    phoneCode: '+690',
  },
  {
    countryAlias: 'Tonga',
    phoneCode: '+676',
  },
  {
    countryAlias: 'TrinidadandTobago',
    phoneCode: '+1-868',
  },
  {
    countryAlias: 'Tunisia',
    phoneCode: '+216',
  },
  {
    countryAlias: 'Turkey',
    phoneCode: '+90',
  },
  {
    countryAlias: 'Turkmenistan',
    phoneCode: '+993',
  },
  {
    countryAlias: 'TurksandCaicosIslands',
    phoneCode: '+1-649',
  },
  {
    countryAlias: 'Tuvalu',
    phoneCode: '+688',
  },
  {
    countryAlias: 'VirginIslandsUS',
    phoneCode: '+1-340',
  },
  {
    countryAlias: 'Uganda',
    phoneCode: '+256',
  },
  {
    countryAlias: 'Ukraine',
    phoneCode: '+380',
  },
  {
    countryAlias: 'UnitedArabEmirates',
    phoneCode: '+971',
  },
  {
    countryAlias: 'UnitedKingdom',
    phoneCode: '+44',
  },
  {
    countryAlias: 'UnitedStates',
    phoneCode: '+1',
  },
  {
    countryAlias: 'Uruguay',
    phoneCode: '+598',
  },
  {
    countryAlias: 'Uzbekistan',
    phoneCode: '+998',
  },
  {
    countryAlias: 'Vanuatu',
    phoneCode: '+678',
  },
  {
    countryAlias: 'HolySee',
    phoneCode: '+379',
  },
  {
    countryAlias: 'VenezuelaBolivarianRepublicof',
    phoneCode: '+58',
  },
  {
    countryAlias: 'VietNam',
    phoneCode: '+84',
  },
  {
    countryAlias: 'WallisandFutuna',
    phoneCode: '+681',
  },
  {
    countryAlias: 'WesternSahara',
    phoneCode: '+212',
  },
  {
    countryAlias: 'Yemen',
    phoneCode: '+967',
  },
  {
    countryAlias: 'Zambia',
    phoneCode: '+260',
  },
  {
    countryAlias: 'Zimbabwe',
    phoneCode: '+263',
  },
];
